export enum STRUCTURED_FILTER_OPERATOR {
  AND = 1,
  OR = 2,
  // NAND = 3,
  NOR = 4,
}

export const structuredFilterOperatorDic: Record<
  STRUCTURED_FILTER_OPERATOR,
  string
> = {
  [STRUCTURED_FILTER_OPERATOR.OR]: 'include any of',
  [STRUCTURED_FILTER_OPERATOR.AND]: 'include all of',
  // [STRUCTURED_FILTER_OPERATOR.NAND]: 'exclude if all',
  [STRUCTURED_FILTER_OPERATOR.NOR]: 'exclude if any of',
};
